import React, { useState } from "react";
import "./invoices.css";
import readXlsxFile from "read-excel-file";
import writeXlsxFile from "write-excel-file";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import {
  buildInvoicePrintModel,
  generateInvoicePdfDataUrl,
  generatePackingListPdfDataUrl,
} from "../../print";
import { amountUsdToWords } from "../../print/utils/numberToWords";
import { APP_VERSION } from "../../appVersion";
// import { fontWeight } from "html2canvas/dist/types/css/property-descriptors/font-weight";

function Invoices(props) {
  const [toAddr, setToAddr] = useState("");
  const [fromAddr, setFromAddr] = useState("");
  const [expName, setExpName] = useState("");
  const [expConPer, setExpConPer] = useState("");
  const [expPerNo, setExpPerNo] = useState("");
  const [expPerEmail, setExpPerEmail] = useState("");
  const [consName, setConName] = useState("");
  const [conConPer, setConConPer] = useState("");
  const [conPerNo, setConPerNo] = useState("");
  const [conPerEmail, setConPerEmail] = useState("");
  const [hsnCode, setHsnCode] = useState("");
  const [partNum, setPartNum] = useState("");
  const [netWt, setNetWt] = useState("");
  const [conOrigin, setConOrigin] = useState("");
  const [itemDes, setItemDes] = useState("");
  const [quantity, setQuantity] = useState("");
  const [price, setPrice] = useState("");
  const [invoiceItemList, setInvoiceItemList] = useState([]);
  const [isEditing, setisEditing] = useState(false);
  const [isBoxEditing, setisBoxEditing] = useState(false);
  const [editIndex, setEditIndex] = useState("");
  const [editBoxIndex, setEditBoxIndex] = useState("");
  const [boxNo, setBoxNo] = useState();
  const [boxWt, setBoxWt] = useState();
  const [boxL, setBoxLen] = useState();
  const [boxB, setBoxB] = useState();
  const [boxW, setBoxW] = useState();
  const [boxGrossWt, setBoxGrossWt] = useState();
  const [boxNetWt, setBoxNetWt] = useState();
  const [invoiceBoxList, setInvoiceBoxList] = useState([]);
  const [file, setFile] = useState();
  const [handInst, setHandInst] = useState();
  const [handNetWt, setHandNetWt] = useState();
  const [handGrossWt, setHandGrossWt] = useState();
  const [freight, setFreight] = useState();
  const [preCarr, setPreCarr] = useState();
  const [companyLUT, setCompanyLUT] = useState("");
  const [flightNo, setFlightNo] = useState("");
  const [portDis, setPortDis] = useState("");
  const [placeRecip, setPlaceRecip] = useState(" ");
  const [portLoad, setPortLoad] = useState("");
  const [finalDest, setFinalDest] = useState("");
  const [buyerId, setBuyerId] = useState();
  const [conMan, setConMan] = useState();
  const [conExp, setConExp] = useState();
  const [conDest, setConDest] = useState();
  const [invNo, setInvNo] = useState("");
  const [invDate, setInvDate] = useState(new Date());
  const [ieCode, setIeCode] = useState();
  const [ordNo, setOrdNo] = useState();
  const [ordDate, setOrdDate] = useState(new Date());
  const [termsDnP, setTermsDnP] = useState("");
  const [exWorks, setExWorks] = useState();
  const [payTerms, setPayTerms] = useState();
  const [advPay, setAdvPay] = useState();
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);

  // (removed old debug useEffect block)

  const updateItemField = (index, field, value) => {
    setInvoiceItemList((prev) => {
      const next = [...prev];
      const item = { ...next[index] };
      item[field] = value;
      next[index] = item;
      return next;
    });
  };

  const updateBoxField = (index, field, value) => {
    setInvoiceBoxList((prev) => {
      const next = [...prev];
      const box = { ...next[index] };
      box[field] = value;
      next[index] = box;
      return next;
    });
  };

  const delItem = (index) => {
    const updatedList = invoiceItemList.filter((_, i) => i !== index);
    setInvoiceItemList(updatedList);
  };

  const editItem = (index) => {
    const selectedItem = invoiceItemList[index];
    setHsnCode(selectedItem.hsncode);
    setItemDes(selectedItem.des);
    setPartNum(selectedItem.partnum);
    setNetWt(selectedItem.netwt);
    setConOrigin(selectedItem.con);
    setQuantity(selectedItem.quantity);
    setPrice(selectedItem.price);
    setisEditing(true);
    setEditIndex(index);
  };
  const addItem = () => {
    if (hsnCode && itemDes && quantity && price) {
      let item = {
        hsncode: hsnCode,
        des: itemDes,
        partnum: partNum,
        netwt: netWt,
        con: conOrigin,
        quantity: quantity,
        price: price,
      };
      if (isEditing) {
        const updatedList = [...invoiceItemList];
        updatedList.splice(editIndex, 1, item);
        setInvoiceItemList(updatedList);
      } else {
        setInvoiceItemList([...invoiceItemList, item]);
      }
      setHsnCode("");
      setItemDes("");
      setPartNum("");
      setNetWt("");
      setConOrigin("");
      setQuantity("");
      setPrice("");
      setisEditing(false);
      setEditIndex("");
    } else {
      alert("please enter required fields");
    }
  };

  const addBox = () => {
    if (boxNo && boxWt && boxNetWt && boxL && boxB && boxW) {
      let box = {
        boxno: boxNo,
        boxwt: boxWt, // Box weight (for gross weight calculation)
        boxl: boxL,
        boxb: boxB,
        boxw: boxW,
        boxnetwt: boxNetWt, // Net weight
      };
      if (isBoxEditing) {
        const updatedBoxList = [...invoiceBoxList];
        updatedBoxList.splice(editBoxIndex, 1, box);
        setInvoiceBoxList(updatedBoxList);
      } else {
        setInvoiceBoxList([...invoiceBoxList, box]);
      }
      setBoxNo("");
      setBoxWt("");
      setBoxLen("");
      setBoxB("");
      setBoxW("");
      setBoxNetWt("");
      setisBoxEditing(false);
      setEditBoxIndex("");
    } else {
      alert("please enter required fields");
    }
  };

  const editBox = (index) => {
    const selectedBox = invoiceBoxList[index];
    setBoxNo(selectedBox.boxno);
    setBoxWt(selectedBox.boxwt);
    setBoxLen(selectedBox.boxl);
    setBoxB(selectedBox.boxb);
    setBoxW(selectedBox.boxw);
    setBoxNetWt(selectedBox.boxnetwt || selectedBox.boxwt || "");
    setisBoxEditing(true);
    setEditBoxIndex(index);
  };

  const delBox = (index) => {
    const updatedBoxList = invoiceBoxList.filter((_, i) => i !== index);
    setInvoiceBoxList(updatedBoxList);
  };

  const subTotal = () => {
    var sum = 0.0;
    for (var i in invoiceItemList) {
      sum = sum + Number(invoiceItemList[i].price) * Number(invoiceItemList[i].quantity);
    }
    return sum.toFixed(2);
  };

  const totalQuantity = () => {
    var qty = 0;
    for (var i in invoiceItemList) {
      qty += Number(invoiceItemList[i].quantity);
    }
    return qty;
  };

  const totalWeight = () => {
    var wt = 0;
    for (var i in invoiceBoxList) {
      wt += Number(invoiceBoxList[i].boxwt);
    }
    return wt;
  };
  const exporterDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Exporter Details</h2>
        <div className="form-grid">
          <div className="form-field">
            <label htmlFor="exporter" className="form-label">Exporter Name</label>
            <input
              type="text"
              id="expname"
              className="form-input"
              value={expName}
              onChange={(e) => setExpName(e.target.value)}
              name="expname"
            />
          </div>

          <div className="form-field">
            <label htmlFor="from" className="form-label">From</label>
            <textarea
              id="from"
              name="from"
              className="form-textarea"
              rows="5"
              value={fromAddr}
              onChange={(e) => setFromAddr(e.target.value)}
            ></textarea>
          </div>

          <div className="form-field">
            <label htmlFor="expcontact" className="form-label">Contact Person Name</label>
            <input
              type="text"
              id="expcontact"
              className="form-input"
              value={expConPer}
              onChange={(e) => setExpConPer(e.target.value)}
              name="expcontact"
            />
          </div>

          <div className="form-field">
            <label htmlFor="phone" className="form-label">Contact Person Phone Number</label>
            <input
              type="tel"
              id="phone"
              className="form-input"
              value={expPerNo}
              onChange={(e) => setExpPerNo(e.target.value)}
              name="phone"
            />
          </div>

          <div className="form-field">
            <label htmlFor="email" className="form-label">Contact Person Email</label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={expPerEmail}
              onChange={(e) => setExpPerEmail(e.target.value)}
              name="email"
            />
          </div>
        </div>
      </div>
    );
  };

  const consigneDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Consignee Details</h2>
        <div className="form-grid">
          <div className="form-field">
            <label htmlFor="consignee" className="form-label">Consignee Name</label>
            <input
              type="text"
              id="conname"
              className="form-input"
              value={consName}
              onChange={(e) => setConName(e.target.value)}
              name="conname"
            />
          </div>

          <div className="form-field">
            <label htmlFor="to" className="form-label">To</label>
            <textarea
              id="to"
              name="to"
              className="form-textarea"
              rows="5"
              value={toAddr}
              onChange={(e) => {
                setToAddr(e.target.value);
              }}
            />
          </div>

          <div className="form-field">
            <label htmlFor="concontact" className="form-label">Contact Person Name</label>
            <input
              type="text"
              id="concontact"
              className="form-input"
              value={conConPer}
              onChange={(e) => setConConPer(e.target.value)}
              name="concontact"
            />
          </div>

          <div className="form-field">
            <label htmlFor="conphone" className="form-label">Contact Person Phone Number</label>
            <input
              type="tel"
              id="conphone"
              className="form-input"
              value={conPerNo}
              onChange={(e) => setConPerNo(e.target.value)}
              name="conphone"
            />
          </div>

          <div className="form-field">
            <label htmlFor="conemail" className="form-label">Contact Person Email</label>
            <input
              type="email"
              id="conemail"
              className="form-input"
              value={conPerEmail}
              onChange={(e) => setConPerEmail(e.target.value)}
              name="conemail"
            />
          </div>
        </div>
      </div>
    );
  };

  const invoiceDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Invoice Details</h2>
        <div className="form-grid">
          <div className="form-field">
            <label htmlFor="invnum" className="form-label">Invoice Number</label>
            <input
              type="text"
              id="invno"
              className="form-input"
              value={invNo}
              onChange={(e) => setInvNo(e.target.value)}
              name="invno"
            />
          </div>

          <div className="form-field">
            <label htmlFor="date" className="form-label">Invoice Date</label>
            <input
              type="date"
              id="date"
              className="form-input"
              style={{ width: "200px", maxWidth: "200px" }}
              value={invDate ? invDate.toISOString().split("T")[0] : ""}
              onChange={(e) => setInvDate(new Date(e.target.value))}
              name="date"
            />
          </div>

          <div className="form-field">
            <label htmlFor="iecode" className="form-label">IE Code</label>
            <input
              type="text"
              id="ie"
              className="form-input"
              value={ieCode}
              onChange={(e) => setIeCode(e.target.value)}
              name="ie"
            />
          </div>

          {orderDetails()}
        </div>
      </div>
    );
  };

  const orderDetails = () => {
    return (
      <>
        <div className="form-field">
          <label htmlFor="buyord" className="form-label">Buyers Order Number</label>
          <input
            type="text"
            id="buyord"
            className="form-input"
            value={ordNo}
            onChange={(e) => setOrdNo(e.target.value)}
            name="buyord"
          />
        </div>

        <div className="form-field">
          <label htmlFor="date1" className="form-label">Order Date</label>
          <input
            type="date"
            id="date1"
            className="form-input"
            style={{ width: "200px", maxWidth: "200px" }}
            value={ordDate ? ordDate.toISOString().split("T")[0] : ""}
            onChange={(e) => setOrdDate(new Date(e.target.value))}
            name="date1"
          />
        </div>
      </>
    );
  };

  const shippingDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Shipping Details</h2>
        <div className="responsive-grid-3">
          <div className="form-field">
            <label htmlFor="carriage" className="form-label">Pre-carriage by</label>
            <input
              type="text"
              id="carriage"
              className="form-input"
              value={preCarr}
              onChange={(e) => setPreCarr(e.target.value)}
              name="carriage"
            />
          </div>
          <div className="form-field">
            <label htmlFor="vessel" className="form-label">Vessel/Flight No</label>
            <input
              type="text"
              id="vessel"
              className="form-input"
              value={flightNo}
              onChange={(e) => setFlightNo(e.target.value)}
              name="vessel"
            />
          </div>
          <div className="form-field">
            <label htmlFor="portl" className="form-label">Port of Loading</label>
            <input
              type="text"
              id="portl"
              className="form-input"
              value={portLoad}
              onChange={(e) => setPortLoad(e.target.value)}
              name="portl"
            />
          </div>
          <div className="form-field">
            <label htmlFor="portd" className="form-label">Port of Discharge</label>
            <input
              type="text"
              id="portd"
              className="form-input"
              value={portDis}
              onChange={(e) => setPortDis(e.target.value)}
              name="portd"
            />
          </div>
          <div className="form-field">
            <label htmlFor="dest" className="form-label">Final Destination</label>
            <input
              type="text"
              id="dest"
              className="form-input"
              value={finalDest}
              onChange={(e) => setFinalDest(e.target.value)}
              name="dest"
            />
          </div>
          <div className="form-field">
            <label htmlFor="place" className="form-label">Place of Receipt</label>
            <input
              type="text"
              id="place"
              className="form-input"
              value={placeRecip}
              onChange={(e) => setPlaceRecip(e.target.value)}
              name="place"
              placeholder="By Pre-carrier"
            />
          </div>
        </div>
      </div>
    );
  };

  const PaymentDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Payment Details</h2>
        <div className="form-field">
          <label htmlFor="termsd" className="form-label">Terms of Delivery and Payment</label>
            <textarea
              id="termsd"
              name="termsd"
            className="form-textarea"
              rows="5"
              value={termsDnP}
              onChange={(e) => setTermsDnP(e.target.value)}
            />
        </div>
      </div>
    );
  };

  const carrierDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Carrier Details</h2>
        <div className="form-field">
          <label htmlFor="buyer" className="form-label">buyer (if other than consignee)</label>
            <input
              type="text"
              id="buyer"
              name="buyer"
              className="form-input"
              value={buyerId}
              onChange={(e) => setBuyerId(e.target.value)}
            />
          </div>
        <div className="responsive-grid-3">
          <div className="form-field">
            <label htmlFor="conm" className="form-label">Country of Manufacture</label>
              <input
                type="text"
                id="conm"
                name="conm"
              className="form-input"
                value={conMan}
                onChange={(e) => setConMan(e.target.value)}
              />
            </div>
          <div className="form-field">
            <label htmlFor="cone" className="form-label">Country of Export</label>
              <input
                type="text"
                id="cone"
                name="cone"
              className="form-input"
                value={conExp}
                onChange={(e) => setConExp(e.target.value)}
              />
            </div>
          <div className="form-field">
            <label htmlFor="cond" className="form-label">Country of Final Destination</label>
              <input
                type="text"
                id="cond"
                name="cond"
              className="form-input"
                value={conDest}
                onChange={(e) => setConDest(e.target.value)}
            />
          </div>
        </div>
      </div>
    );
  };

  const handlingDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Handling Details</h2>
        <div className="form-field">
          <label htmlFor="inst" className="form-label">Handling Instructions</label>
            <textarea
              id="inst"
              name="inst"
            className="form-textarea"
              value={handInst}
              onChange={(e) => setHandInst(e.target.value)}
              rows="5"
          />
          </div>
        <div className="responsive-grid-2">
          <div className="form-field">
            <label htmlFor="netwt" className="form-label">Net Weight KG</label>
              <input
                type="text"
                id="netwt"
              className="form-input"
                value={handNetWt}
                onChange={(e) => setHandNetWt(e.target.value)}
                name="netwt"
              />
            </div>
          <div className="form-field">
            <label htmlFor="grosswt" className="form-label">Gross Weight KG</label>
              <input
                type="text"
                id="grosswt"
              className="form-input"
                value={handGrossWt}
                onChange={(e) => setHandGrossWt(e.target.value)}
                name="grosswt"
              />
            </div>
          <div className="form-field">
            <label htmlFor="frght" className="form-label">Freight</label>
              <input
                type="number"
                id="frght"
              className="form-input"
                value={freight}
                onChange={(e) => setFreight(e.target.value)}
                name="frght"
              />
            </div>
          <div className="form-field">
            <label htmlFor="companylut" className="form-label">Company's LUT</label>
            <input
              type="text"
              id="companylut"
              className="form-input"
              value={companyLUT}
              onChange={(e) => setCompanyLUT(e.target.value)}
              name="companylut"
            />
          </div>
        </div>
      </div>
    );
  };

  const newBoxDetails = () => {
    return (
      <div>
        <div className="responsive-grid-2">
          <div className="form-field">
            <label htmlFor="boxno" className="form-label">Box No</label>
            <input
              type="number"
              id="boxno"
              className="form-input"
              value={boxNo}
              onChange={(e) => setBoxNo(e.target.value)}
              name="boxno"
            />
          </div>
          <div className="form-field">
            <label htmlFor="boxwt" className="form-label">Box Weight (KGs)</label>
            <input
              type="number"
              id="boxwt"
              className="form-input"
              value={boxWt}
              onChange={(e) => setBoxWt(e.target.value)}
              name="boxwt"
            />
          </div>
          <div className="form-field">
            <label htmlFor="boxl" className="form-label">Box Length (cms)</label>
            <input
              type="number"
              id="boxl"
              className="form-input"
              value={boxL}
              onChange={(e) => setBoxLen(e.target.value)}
              name="boxl"
            />
          </div>
          <div className="form-field">
            <label htmlFor="boxb" className="form-label">Box Breadth (cms)</label>
            <input
              type="number"
              id="boxb"
              className="form-input"
              value={boxB}
              onChange={(e) => setBoxB(e.target.value)}
              name="boxb"
            />
          </div>
          <div className="form-field">
            <label htmlFor="boxh" className="form-label">Box Height (cms)</label>
            <input
              type="number"
              id="boxh"
              className="form-input"
              value={boxW}
              onChange={(e) => setBoxW(e.target.value)}
              name="boxh"
            />
          </div>
          <div className="form-field">
            <label htmlFor="boxnetwt" className="form-label">Box Net Weight (KGs)</label>
            <input
              type="number"
              id="boxnetwt"
              className="form-input"
              value={boxNetWt}
              onChange={(e) => setBoxNetWt(e.target.value)}
              name="boxnetwt"
            />
          </div>
        </div>
        <div className="button-group">
            <button
              type="button"
              onClick={addBox}
              disabled={!invoiceItemList}
            className="btn-success"
            >
              {isBoxEditing ? "Update Box" : "Add Box"}
            </button>
        </div>
      </div>
    );
  };
  const calcDetail = () => {
    return (
      <div className="summary-box">
        <h3 className="section-subtitle">Summary</h3>
        <div className="summary-item">
          <span className="summary-label">Total Items</span>
          <span className="summary-value">{invoiceItemList.length}</span>
          </div>
        <div className="summary-item">
          <span className="summary-label">Total Quantity</span>
          <span className="summary-value">{totalQuantity()}</span>
          </div>
        <div className="summary-item">
          <span className="summary-label">Sub Total</span>
          <span className="summary-value">{subTotal()}</span>
          </div>
        <div className="summary-item">
          <span className="summary-label">Total</span>
          <span className="summary-value">{subTotal()}</span>
        </div>
      </div>
    );
  };

  const calcBox = () => {
    return (
      <div className="summary-box">
        <h3 className="section-subtitle">Box Summary</h3>
        <div className="summary-item">
          <span className="summary-label">Total Boxes</span>
          <span className="summary-value">{invoiceBoxList.length}</span>
          </div>
        <div className="summary-item">
          <span className="summary-label">Total Net Weight (KGs)</span>
          <span className="summary-value">{totalWeight()}</span>
          </div>
        <div className="summary-item">
          <span className="summary-label">Total Gross Weight</span>
          <span className="summary-value">-</span>
        </div>
      </div>
    );
  };

  const newItemDetails = () => {
    return (
      <div>
        <div className="form-field">
          <label htmlFor="des" className="form-label">Description of Goods/Part Number</label>
            <textarea
              id="des"
              name="des"
            className="form-textarea"
              rows="3"
              value={itemDes}
              onChange={(e) => setItemDes(e.target.value)}
          />
          </div>
        <div className="responsive-grid-3">
          <div className="form-field">
            <label htmlFor="part" className="form-label">Part Number</label>
            <textarea
              id="part"
              name="part"
              className="form-textarea"
              rows="1"
              value={partNum}
              onChange={(e) => setPartNum(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label htmlFor="netwt" className="form-label">Net Weight KG</label>
            <input
              type="number"
              id="netwt"
              className="form-input"
              name="netwt"
              value={netWt}
              min={0}
              onChange={(e) => setNetWt(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label htmlFor="con" className="form-label">Country of Origin</label>
            <input
              type="text"
              id="con"
              className="form-input"
              name="con"
              value={conOrigin}
              onChange={(e) => setConOrigin(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label htmlFor="icode" className="form-label">HSN Code</label>
            <input
              type="text"
              id="icode"
              className="form-input"
              name="icode"
              value={hsnCode}
              onChange={(e) => setHsnCode(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label htmlFor="quantity" className="form-label">Quantity</label>
            <input
              type="number"
              id="quantity"
              className="form-input"
              name="quantity"
              value={quantity}
              min={0}
              onChange={(e) => setQuantity(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label htmlFor="price" className="form-label">Rate (USD)</label>
            <input
              type="number"
              id="price"
              className="form-input"
              name="price"
              value={price}
              min={0}
              onChange={(e) => setPrice(e.target.value)}
            />
          </div>
          <div className="form-field">
            <label htmlFor="amount" className="form-label">Amount (USD)</label>
            <input
              type="number"
              id="amount"
              className="form-input"
              name="amount"
              value={(Number(price) || 0) * (Number(quantity) || 0)}
              readOnly
            />
          </div>
        </div>
        <div className="button-group">
            <button
              type="button"
              onClick={addItem}
              disabled={!invoiceItemList}
            className="btn-success"
            >
              {isEditing ? "Update Item" : "Add Item"}
            </button>
        </div>
      </div>
    );
  };

  const itemTableDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Invoice Items</h2>
        <table>
          <thead>
            <tr>
              <th>S.NO</th>
              <th>Item Description</th>
              <th>HSN Code</th>
              <th>Part Number</th>
              <th>Quantity</th>
              <th>Net Weight KG</th>
              <th>Price (USD)</th>
              <th>Amount (USD)</th>
              <th>Edit</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            {invoiceItemList.map((item, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td>
                  <input
                    className="table-input"
                    type="text"
                    value={item.des}
                    onChange={(e) => updateItemField(index, "des", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    className="table-input"
                    type="text"
                    value={item.hsncode}
                    onChange={(e) => updateItemField(index, "hsncode", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    className="table-input"
                    type="text"
                    value={item.partnum}
                    onChange={(e) => updateItemField(index, "partnum", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={item.quantity}
                    min={0}
                    onChange={(e) => updateItemField(index, "quantity", e.target.value)}
                  />
                </td>
                <td>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={item.netwt}
                    min={0}
                    onChange={(e) => updateItemField(index, "netwt", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={item.price}
                    min={0}
                    onChange={(e) => updateItemField(index, "price", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  {Number((Number(item.price) || 0) * (Number(item.quantity) || 0)).toFixed(2)}
                </td>
                <td style={{ textAlign: "center" }}>
                  <button type="button" className="btn" onClick={() => editItem(index)}>
                    Edit
                  </button>
                </td>
                <td style={{ textAlign: "center" }}>
                  <button type="button" className="btn btn-danger" onClick={() => delItem(index)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const boxTableDetails = () => {
    return (
      <div className="modern-section">
        <h2 className="section-title">Box Details</h2>
        <table>
          <thead>
            <tr>
              <th>S.NO</th>
              <th style={{ textAlign: "right" }}>Box No</th>
              <th style={{ textAlign: "right" }}>Box Weight (KGs)</th>
              <th style={{ textAlign: "right" }}>Net Weight (KGs)</th>
              <th style={{ textAlign: "right" }}>Box Length (cms)</th>
              <th style={{ textAlign: "right" }}>Box Breadth (cms)</th>
              <th style={{ textAlign: "right" }}>Box Height (cms)</th>
              <th style={{ textAlign: "center" }}>Edit</th>
              <th style={{ textAlign: "center" }}>Delete</th>
            </tr>
          </thead>
          <tbody>
            {invoiceBoxList.map((box, index) => (
              <tr key={index}>
                <td style={{ textAlign: "center" }}>{index + 1}</td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={box.boxno}
                    onChange={(e) => updateBoxField(index, "boxno", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={box.boxwt}
                    onChange={(e) => updateBoxField(index, "boxwt", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={box.boxnetwt || ""}
                    onChange={(e) => updateBoxField(index, "boxnetwt", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={box.boxl}
                    onChange={(e) => updateBoxField(index, "boxl", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={box.boxb}
                    onChange={(e) => updateBoxField(index, "boxb", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "right" }}>
                  <input
                    className="table-input table-input-number"
                    type="number"
                    value={box.boxw}
                    onChange={(e) => updateBoxField(index, "boxw", e.target.value)}
                  />
                </td>
                <td style={{ textAlign: "center" }}>
                  <button type="button" className="btn" onClick={() => editBox(index)}>
                    Edit
                  </button>
                </td>
                <td style={{ textAlign: "center" }}>
                  <button type="button" className="btn btn-danger" onClick={() => delBox(index)}>
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  const handleFileImport = () => {
    if (!file) {
      alert("please select file");
      return;
    } else {
      processFile(file);
    }
  };

  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
    processFile(event.target.files[0]);
  };

  const processFile = (file) => {
    if (file) {
      // Read multiple sheets sequentially
      readXlsxFile(file, { sheet: "ExporterConsignee" }).then((rows) => {
        // setExpConsData([rows]);
        if (!rows || rows.length < 2) {
          console.warn("ExporterConsignee sheet is empty or missing data");
          return;
        }
        var exporterConsigneeData = {};
        exporterConsigneeData["exporterName"] = rows[1][0] || "";
        exporterConsigneeData["fromAddr"] = rows[1][1] || "";
        exporterConsigneeData["exporterContactPerson"] = rows[1][2] || "";
        exporterConsigneeData["exporterContactNumber"] = rows[1][3] || "";
        exporterConsigneeData["exporterEmail"] = rows[1][4] || "";
        exporterConsigneeData["consgineeName"] = rows[1][5] || "";
        exporterConsigneeData["toAddr"] = rows[1][6] || "";
        exporterConsigneeData["consigneeContactPerson"] = rows[1][7] || "";
        exporterConsigneeData["consigneeContactNumber"] = rows[1][8] || "";
        exporterConsigneeData["consigneeEmail"] = rows[1][9] || "";

        setFromAddr(exporterConsigneeData["fromAddr"]);
        setToAddr(rows[1][6] || "");
        setConName(rows[1][5] || "");
        setExpName(rows[1][0] || "");
        setExpConPer(rows[1][2] || "");
        setConConPer(rows[1][7] || "");
        setExpPerNo(rows[1][3] || "");
        setConPerNo(rows[1][8] || "");
        setExpPerEmail(exporterConsigneeData.exporterEmail);
        setConPerEmail(exporterConsigneeData.consigneeEmail);

        // setExpConsData([exporterConsigneeData]);
      }).catch((error) => {
        console.error("Error reading ExporterConsignee sheet:", error);
      });

      readXlsxFile(file, { sheet: "ProductItems" }).then((rows) => {
        //  setItemData(rows);
        var itemData = {};
        let new_invoiceItemList = [];
        for (var i = 1; i < rows.length; i++) {
          // Skip empty rows
          if (!rows[i] || rows[i].length === 0 || !rows[i][0]) continue;
          
          itemData["Description of Goods/Part Number"] = rows[i][0] || "";
          itemData["Part Number"] = rows[i][1] || "";
          itemData["Net Weight KG"] = rows[i][2] || "";
          itemData["Country of Origin"] = rows[i][3] || "";
          itemData["HSN Code"] = rows[i][4] || "";
          itemData["Qty"] = rows[i][5] || "";
          itemData["Rate(USD)"] = rows[i][6] || "";

          let item = {
            hsncode: itemData["HSN Code"],
            des: itemData["Description of Goods/Part Number"],
            partnum: itemData["Part Number"],
            netwt: itemData["Net Weight KG"],
            con: itemData["Country of Origin"],
            quantity: itemData.Qty,
            price: itemData["Rate(USD)"],
          };

          new_invoiceItemList.push(item);
        }
        setInvoiceItemList(new_invoiceItemList);
      }).catch((error) => {
        console.error("Error reading ProductItems sheet:", error);
      });

      readXlsxFile(file, { sheet: "handlingDetails" }).then((rows) => {
        //   setHandlingData(rows);
        if (!rows || rows.length < 2) {
          console.warn("handlingDetails sheet is empty or missing data");
          return;
        }
        var handlingData = {};
        handlingData["handInst"] = rows[1][0] || "";
        handlingData["netwt"] = rows[1][1] || "";
        handlingData["grosswt"] = rows[1][2] || "";

        setHandInst(handlingData.handInst);
        setHandNetWt(handlingData.netwt);
        setHandGrossWt(handlingData.grosswt);
      }).catch((error) => {
        console.error("Error reading handlingDetails sheet:", error);
      });

      readXlsxFile(file, { sheet: "shippingDetails" }).then((rows) => {
        // setShippingData(rows);
        if (!rows || rows.length < 2) {
          console.warn("shippingDetails sheet is empty or missing data");
          return;
        }
        var shippingData = {};
        shippingData["preCarr"] = rows[1][0] || "";
        shippingData["flightNo"] = rows[1][1] || "";
        shippingData["portDis"] = rows[1][2] || "";
        shippingData["placeRec"] = rows[1][3] || "";
        shippingData["portLoad"] = rows[1][4] || "";
        shippingData["finalDest"] = rows[1][5] || "";

        setPreCarr(shippingData.preCarr);
        setFlightNo(shippingData.flightNo);
        setPortDis(shippingData.portDis);
        setPlaceRecip(shippingData.placeRec);
        setPortLoad(shippingData.portLoad);
        setFinalDest(shippingData.finalDest);
      }).catch((error) => {
        console.error("Error reading shippingDetails sheet:", error);
      });

      readXlsxFile(file, { sheet: "carrierDetails" }).then((rows) => {
        if (!rows || rows.length < 2) {
          console.warn("carrierDetails sheet is empty or missing data");
          return;
        }
        var carrierData = {};
        carrierData["buyerid"] = rows[1][0] || "";
        carrierData["conMan"] = rows[1][1] || "";
        carrierData["conExp"] = rows[1][2] || "";
        carrierData["conDest"] = rows[1][3] || "";

        setBuyerId(carrierData.buyerid);
        setConMan(carrierData.conMan);
        setConExp(carrierData.conExp);
        setConDest(carrierData.conDest);
      }).catch((error) => {
        console.error("Error reading carrierDetails sheet:", error);
      });

      readXlsxFile(file, { sheet: "invoiceDetails" }).then((rows) => {
        if (!rows || rows.length < 2) {
          console.warn("invoiceDetails sheet is empty or missing data");
          return;
        }
        var invoiceData = {};
        invoiceData["invNo"] = rows[1][0] || "";
        invoiceData["invDate"] = rows[1][1] || "";
        invoiceData["ieCode"] = rows[1][2] || "";
        invoiceData["ordNo"] = rows[1][3] || "";
        invoiceData["ordDate"] = rows[1][4] || "";
        invoiceData["companyLUT"] = rows[1][5] || "";

        setInvNo(invoiceData.invNo || "");
        setInvDate(invoiceData.invDate ? new Date(invoiceData.invDate) : new Date());
        setIeCode(invoiceData.ieCode || "");
        setOrdNo(invoiceData.ordNo || "");
        setOrdDate(invoiceData.ordDate ? new Date(invoiceData.ordDate) : new Date());
        setCompanyLUT(invoiceData.companyLUT || "");
      }).catch((error) => {
        console.error("Error reading invoiceDetails sheet:", error);
      });

      readXlsxFile(file, { sheet: "boxDetails" }).then((rows) => {
        if (!rows || rows.length < 2) {
          console.warn("boxDetails sheet is empty or missing data");
          setInvoiceBoxList([]);
          return;
        }
        let new_invoiceBoxList = [];
        for (var i = 1; i < rows.length; i++) {
          // Skip if row doesn't exist
          if (!rows[i]) continue;
          
          // Get values safely - Excel may have sparse arrays
          const boxNo = rows[i][0];
          const boxWeight = rows[i][1];
          const boxLength = rows[i][2];
          const boxBreadth = rows[i][3];
          const boxWidth = rows[i][4];
          const netwt = rows[i][5];
          const grosswt = rows[i][6];
          
          // Skip rows where Box No is empty/null/undefined
          if (boxNo === null || boxNo === undefined || boxNo === "" || (typeof boxNo === 'string' && boxNo.trim() === "")) {
            continue;
          }
          
          // Convert to strings and trim, handling null/undefined
          const getValue = (val) => {
            if (val === null || val === undefined) return "";
            return String(val).trim();
          };

          let box = {
            boxno: getValue(boxNo),
            boxwt: getValue(boxWeight) || getValue(grosswt) || "",
            boxl: getValue(boxLength),
            boxb: getValue(boxBreadth),
            boxw: getValue(boxWidth),
            boxnetwt: getValue(netwt) || "",
          };
          
          new_invoiceBoxList.push(box);
        }
        setInvoiceBoxList(new_invoiceBoxList);
      }).catch((error) => {
        console.error("Error reading boxDetails sheet:", error);
        setInvoiceBoxList([]);
      });
    }
  };

  const writeXl = () => {
    const items_headers = [
      {
        value: "Description of Goods/Part Number",
        fontWeight: "bold",
      },
      {
        value: "Part Number",
        fontWeight: "bold",
      },
      {
        value: "Net Weight KG",
        fontWeight: "bold",
      },
      {
        value: "Country of Origin",
        fontWeight: "bold",
      },
      {
        value: "HSN Code",
        fontWeight: "bold",
      },
      {
        value: "Qty",
        fontWeight: "bold",
      },
      {
        value: "Rate(USD)",
        fontWeight: "bold",
      },
      {
        value: "Amount(USD)",
        fontWeight: "bold",
      },
    ];
    //   const expCons_rows = invoiceItemList.map((row, index) => {
    //     return[
    //     { type: String, value: row.itemDes },
    //     { type: String, value: row.partNum },
    //     { type: Number, value: Number(row.netWt) },
    //     { type: String, value: row.conOrigin },
    //     { type: String, value: row.hsnCode },
    //     { type: Number, value: Number(row.quantity) },
    //     { type: Number, value: Number(row.price) },
    //     { type: Number, value: Number(row.price*row.quantity) }
    //   ];
    // });
    const items_rows = [];
    const items_data = [items_headers];
    const inv_rows = () => {
      for (let i = 0; i < invoiceItemList.length; i++) {
        // let record = [
        const i1 = invoiceItemList[i].des;
        const i2 = invoiceItemList[i].partnum;
        const i3 = invoiceItemList[i].netwt;
        const i4 = invoiceItemList[i].con;
        const i5 = invoiceItemList[i].hsncode;
        const i6 = invoiceItemList[i].quantity;
        const i7 = invoiceItemList[i].price;
        const i8 = Number(
          invoiceItemList[i].price * invoiceItemList[i].quantity
        ).toFixed(2);
        // ];
        const record = [
          {
            type: String,
            value: i1,
          },
          {
            type: String,
            value: i2,
          },
          {
            type: String,
            value: i3.toString(),
          },
          {
            type: String,
            value: i4,
          },
          {
            type: String,
            value: i5.toString(),
          },
          {
            type: String,
            value: i6.toString(),
          },
          {
            type: String,
            value: i7.toString(),
          },
          {
            type: String,
            value: i8.toString(),
          },
        ];
        items_rows.push(record);
        items_data.push(record);
      }
    };
    inv_rows();

    //Box Details Data

    const box_headers = [
      {
        value: "Box No",
        fontWeight: "bold",
      },
      {
        value: "Box Weight (KGs)",
        fontWeight: "bold",
      },
      {
        value: "Box Length (cms)",
        fontWeight: "bold",
      },
      {
        value: "Box Breadth (cms)",
        fontWeight: "bold",
      },
      {
        value: "Box Height (cms)",
        fontWeight: "bold",
      },
      {
        value: "Net Weight (KGs)",
        fontWeight: "bold",
      },
      {
        value: "Gross Weight (KGs)",
        fontWeight: "bold",
      },
    ];

    const box_rows = [];
    const box_data = [box_headers];
    const boxes_rows = () => {
      for (let i = 0; i < invoiceBoxList.length; i++) {
        // let record = [
        const b1 = invoiceBoxList[i].boxno;
        const b2 = invoiceBoxList[i].boxwt;
        const b3 = invoiceBoxList[i].boxl;
        const b4 = invoiceBoxList[i].boxb;
        const b5 = invoiceBoxList[i].boxw; // Box height/width
        const b6 = Number(invoiceBoxList[i].boxnetwt || 0); // Net weight
        const b7 = Number(invoiceBoxList[i].boxwt || 0); // Gross weight (box weight)

        const b_record = [
          {
            type: String,
            value: b1.toString(),
          },
          {
            type: String,
            value: b2.toString(),
          },
          {
            type: String,
            value: b3.toString(),
          },
          {
            type: String,
            value: b4.toString(),
          },
          {
            type: String,
            value: b5.toString(),
          },
          {
            type: String,
            value: b6.toString(),
          },
          {
            type: String,
            value: b7.toString(),
          },
        ];
        box_rows.push(b_record);
        box_data.push(b_record);
      }
    };
    boxes_rows();

    // Handling Details Data?
    const handling_headers = [
      {
        value: "Handling Instructions",
        fontWeight: "bold",
      },
      {
        value: "Net Weight KG",
        fontWeight: "bold",
      },
      {
        value: "Gross Weight KG",
        fontWeight: "bold",
      },
    ];
    const handling_row = [
      // "Name"
      {
        type: String,
        value: handInst,
      },

      // "Date of Birth"
      {
        type: String,
        value: handNetWt,
      },

      // "Cost"
      {
        type: String,
        value: handGrossWt,
      },
    ];

    const handling_data = [handling_headers, handling_row];

    // Carrier Details Data
    const carrier_headers = [
      {
        value: "buyer (if other than consignee)",
        fontWeight: "bold",
      },
      {
        value: "Country of Manufacture",
        fontWeight: "bold",
      },
      {
        value: "Country of Export",
        fontWeight: "bold",
      },
      {
        value: "Country of Final Destination",
        fontWeight: "bold",
      },
    ];
    const carrier_row = [
      {
        type: String,
        value: buyerId || "",
      },
      {
        type: String,
        value: conMan,
      },
      {
        type: String,
        value: conExp,
      },
      {
        type: String,
        value: conDest,
      },
    ];

    const carrier_data = [carrier_headers, carrier_row];

    // Carrier Details Data
    const invoice_headers = [
      {
        value: "invoice number",
        fontWeight: "bold",
      },
      {
        value: "invoice date",
        fontWeight: "bold",
      },
      {
        value: "IE Code",
        fontWeight: "bold",
      },
      {
        value: "buyers order no",
        fontWeight: "bold",
      },
      {
        value: "Date",
        fontWeight: "bold",
      },
      {
        value: "Company's LUT",
        fontWeight: "bold",
      },
    ];
    const invoice_row = [
      {
        type: String,
        value: invNo,
      },
      {
        type: Date,
        value: invDate ? new Date(invDate.toISOString().split("T")[0]) : new Date(),
        format: "dd-MM-yyyy",
      },
      {
        type: String,
        value: ieCode,
      },
      {
        type: String,
        value: ordNo,
      },
      {
        type: Date,
        value: ordDate ? new Date(ordDate.toISOString().split("T")[0]) : new Date(),
        format: "dd-MM-yyyy",
      },
      {
        type: String,
        value: companyLUT || "",
      },
    ];

    const invoice_data = [invoice_headers, invoice_row];

    // Shipping Details Data
    const shipping_headers = [
      {
        value: "Pre-carriage by",
        fontWeight: "bold",
      },
      {
        value: "Vessel/Flight No",
        fontWeight: "bold",
      },
      {
        value: "Port of Discharge",
        fontWeight: "bold",
      },
      {
        value: "Place of reciept by pre-carrier",
        fontWeight: "bold",
      },
      {
        value: "Port of Loading",
        fontWeight: "bold",
      },
      {
        value: "Final Destination",
        fontWeight: "bold",
      },
    ];
    const shipping_row = [
      {
        type: String,
        value: preCarr,
      },

      {
        type: String,
        value: flightNo,
      },

      {
        type: String,
        value: portDis,
      },
      {
        type: String,
        value: placeRecip,
      },
      {
        type: String,
        value: portLoad,
      },
      {
        type: String,
        value: finalDest,
      },
    ];

    const shipping_data = [shipping_headers, shipping_row];

    //exporter consignee data
    const expCon_headers = [
      {
        value: "Exporter Name",
        fontWeight: "bold",
      },
      {
        value: "Exporter Address",
        fontWeight: "bold",
      },
      {
        value: "Exp Contact Person Name",
        fontWeight: "bold",
      },
      {
        value: "exporter Phone Number",
        fontWeight: "bold",
      },
      {
        value: "exporter email",
        fontWeight: "bold",
      },
      {
        value: "Consignee Name",
        fontWeight: "bold",
      },
      {
        value: "Consignee Address",
        fontWeight: "bold",
      },
      {
        value: "Con Contact Person Name",
        fontWeight: "bold",
      },
      {
        value: "Consignee Phone Number",
        fontWeight: "bold",
      },
      {
        value: "Consignee email",
        fontWeight: "bold",
      },
    ];
    const expCon_row = [
      {
        type: String,
        value: expName,
      },

      {
        type: String,
        value: fromAddr,
      },

      {
        type: String,
        value: expConPer,
      },
      {
        type: String,
        value: (expPerNo || "").toString(),
      },
      {
        type: String,
        value: expPerEmail,
      },
      {
        type: String,
        value: consName,
      },

      {
        type: String,
        value: toAddr,
      },

      {
        type: String,
        value: conConPer,
      },
      {
        type: String,
        value: (conPerNo || "").toString(),
      },
      {
        type: String,
        value: conPerEmail,
      },
    ];

    const expCons_data = [expCon_headers, expCon_row];

    writeXlsxFile(
      [
        expCons_data,
        handling_data,
        shipping_data,
        carrier_data,
        invoice_data,
        items_data,
        box_data,
      ],
      {
        fileName: "file.xlsx",
        sheets: [
          "ExporterConsignee",
          "handlingDetails",
          "shippingDetails",
          "carrierDetails",
          "invoiceDetails",
          "ProductItems",
          "boxDetails",
        ],
      }
    );
  };

  const print_inv_legacy = () => {

    const doc = new jsPDF("p", "mm", "a4");

    //add border
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height; // For A4, it's 297 mm

    const margin = 10;

    // Add Title (with 4 line spacing from top)
    doc.setFontSize(14);
    doc.setFont("helvetica","bold");
    doc.text("COMMERCIAL INVOICE", pageWidth / 2, 40, null, null, "center");

    let x = 10;
    let y = 45;
    doc.rect(x, y, 190, 250);

    doc.rect(x, y, 90, 40); // Left box (x, y, width, height)

    // Add Exporter Details
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Exporter", x + 3, y + 5);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(expName || "", x + 3, y + 12);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    const from_add = doc.splitTextToSize(fromAddr || "", 80);
    doc.text(from_add, x + 3, y + 17);
    const email = doc.splitTextToSize(expPerEmail || "", 80);
    doc.text(email, x + 3, y + 27);
    const expPn = doc.splitTextToSize(expConPer || "", 80);
    doc.text(expPn, x + 3, y + 31);
    const expCn = doc.splitTextToSize(expPerNo || "", 80);
    doc.text(expCn, x + 3, y + 35);

    doc.rect(x, y + 40, 90, 46);
    // Add Consignee Details
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Consignee", x + 3, y + 47);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(consName || "", x + 3, y + 54);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    const to_add = doc.splitTextToSize(toAddr || "", 80);
    doc.text(to_add, x + 3, y + 59);
    doc.text(conPerEmail || "", x + 3, y + 72);
    doc.text(conConPer || "", x + 3, y + 77);
    doc.text((conPerNo || "").toString(), x + 3, y + 82);

    x = x + 90;
    y = 45;
    // Invoice Details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.rect(x, y, 40, 8);
    doc.setFontSize(9);
    doc.text("Invoice No:", x + 2, y + 5);
    doc.setFontSize(10);
    doc.text((invNo || "").toString(), x + 19, y + 5);
    const dateObj = new Date(invDate);

    // Extract components in "DD-MM-YYYY" format
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    doc.rect(x, y + 8, 40, 10);
    doc.setFontSize(9);
    doc.text("Invoice Date: ", x + 2, y + 14);
    doc.text(formattedDate.toString(), x + 21, y + 14);

    doc.rect(x + 40, y, 60, 18);
    doc.setFontSize(10);
    doc.text("IE Code: ", x + 43, y + 10);
    doc.setFontSize(10);
    doc.text(ieCode || "", x + 58, y + 10);

    doc.rect(x, y + 18, 100, 12);
    doc.setFontSize(8);
    doc.text("Buyer's Order No: ", x + 2, y + 22);
    doc.setFontSize(10);
    doc.text(ordNo || "", x + 4, y + 27);
    doc.setFontSize(10);
    //doc.text("24216 && 25244", x + 2, y + 29);
    doc.setFontSize(10);
    // Convert the ordDate string to a Date object
    const orderDate = new Date(ordDate);

    // Extract components for a better date format (DD-MM-YYYY)
    const oday = String(orderDate.getDate()).padStart(2, '0');
    const omonth = String(orderDate.getMonth() + 1).padStart(2, '0');
    const oyear = orderDate.getFullYear();

    const formattedOrderDate = `${oday}-${omonth}-${oyear}`;
    doc.setFontSize(9);
    doc.text("Dated: ", x + 40, y + 23);
    doc.setFontSize(11);
    doc.text(formattedOrderDate.toString(), x + 52, y + 23);
    //doc.text("Dated: 12-Jan-2025", x + 48, y + 29);
    doc.setFontSize(10);
    //Buyer details
    doc.rect(x, y + 30, 100, 26);
    doc.text("Buyer (if other than consignee)", x + 2, y + 35);
    doc.setFontSize(9);
    doc.text(doc.splitTextToSize(buyerId || "", 95), x + 2, y + 42);
    doc.setFontSize(10);
    doc.rect(x, y + 56, 100, 10);
    doc.setFontSize(10);
    doc.text("Country of Manufacture : ", x + 2, y + 61);
    doc.text(conMan || "", x + 50, y + 61);
    doc.rect(x, y + 66, 100, 10);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Country of Export : ", x + 2, y + 70);
    doc.text(conExp || "", x + 50, y + 70);
    doc.rect(x, y + 76, 100, 10);
    doc.text("Country of Final Destination : ", x + 2, y + 80);
    doc.text(conDest || "", x + 50, y + 80);

    //payment details
    doc.rect(x, y + 86, 100, 35);
    doc.text("Terms of delivery and payment:", x + 2, y + 92);
    const terms = doc.splitTextToSize(termsDnP || "", 90);
    doc.text(terms, x + 2, y + 110);

    //carrier details
    x = 10;
    y = 133;
    doc.rect(x, y - 2, 35, 13);
    doc.text("Pre-Carriage By:", x + 2, y + 4);
    doc.text(preCarr || "", x + 5, y + 9);

    doc.rect(x + 35, y - 2, 55, 13);
    doc.text("Place of reciept by pre-carrier:", x + 37, y + 4);
    //doc.text(placeRecip,x+35,y+2);

    doc.rect(x, y + 11, 35, 11);
    doc.text("Vessel/flight No:", x + 2, y + 15);
    if (flightNo) { doc.text(flightNo, x + 2, y + 19); }

    doc.rect(x + 35, y + 11, 55, 11);
    doc.text("Port of loading:", x + 37, y + 15);
    if (portLoad) { doc.text(portLoad, x + 37, y + 19); }
    doc.rect(x, y + 22, 35, 11);
    doc.text("Port of Discharge:", x + 2, y + 26);
    doc.text(portDis || "", x + 2, y + 31);

    doc.rect(x + 35, y + 22, 55, 11);
    doc.text("Final Destination:", x + 37, y + 26);
    doc.text(finalDest || "", x + 37, y + 31);

    // // Table Header
    // Example Data
    const tableData = invoiceItemList.map((item, index) => ({
      sno: index + 1, // Increment index starting from 1
      description: item.des || "N/A", // Handle undefined values
      hsnCode: item.hsncode || "N/A",
      countryOfOrigin: item.con || "N/A",
      quantity: item.quantity || 0,
      rate: item.price || 0,
      amount: (item.quantity || 0) * (item.price || 0), // Calculate amount dynamically
    }));


    const headers = [
      ["S.No", "Description", "HSN Code", "Qty", "Rate (USD)", "Amount (USD)"],
    ];

    // Automatically map table rows based on dynamic data
    const bodyData = tableData.map((item, index) => [
      index + 1,
      item.description,
      item.hsnCode,
      Number(item.quantity.toString()),
      item.rate.toString(),
      Number(item.amount.toString()).toFixed(2),
    ]);

    let yPosition = y + 37;

    autoTable(doc, {
      startY: yPosition,
      head: headers,
      body: bodyData,
      theme: "grid",
      // Prevent splitting a row across pages. If a row doesn't fit, move it fully to the next page.
      // (If a single row is taller than a page, autoTable will still have to split it.)
      rowPageBreak: "avoid",
      margin: { left: 15, right: 15, bottom: 25 },
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [0, 0, 0], // RGB color for the border
        lineWidth: 0.5,       // Border line width
        overflow: "linebreak",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      },
      bodyStyles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        1: { cellWidth: 60 }, // For long text wrapping in Description
        3: { halign: "center" }, // Center Qty column
        4: { halign: "center" }, // Center Rate column
        5: { halign: "center" }, // Center Amount column
      },
      headStyles: {
        fillColor: [235, 235, 235],
        textColor: [0, 0, 0],
        lineWidth: 0.5, // Add border width for header
        lineColor: [0, 0, 0], // Black grid lines for header
      },
    });
  
   
    // Check if lastAutoTable exists before accessing finalY
    if (doc.lastAutoTable && doc.lastAutoTable.finalY !== undefined) {
      yPosition = doc.lastAutoTable.finalY + 10;
    } else {
      // Fallback if table wasn't created
      yPosition = y + 37 + (bodyData.length * 10) + 10;
    }
    let newpage = 0;
    doc.setFont("helvetica", "normal");
    // Use pageHeight-based check instead of hardcoded 270
    // Leave footer space (25mm) to avoid printing in footer area
    const footerSpace = 25;
    const safePageThreshold = pageHeight - footerSpace;
    if (yPosition > safePageThreshold) {
      doc.addPage();
      yPosition = 10; // 10mm top margin
      newpage = 1;
    }
    // Add total section dynamically based on table data
    const totalQty = tableData.reduce((sum, item) => sum + Number(item.quantity), 0);
    const totalAmountNum = Number(tableData.reduce((sum, item) => sum + item.amount, 0));
    const freightAmount = Number(freight) || 0;
    const totalAmountWithFreight = totalAmountNum + freightAmount;
    const totalAmount = totalAmountWithFreight.toFixed(2);

    doc.setFont("helvetica", "bold");
    doc.setFontSize(9);
    //doc.rect(91,yPosition-10,27,9);
    //doc.rect(118,yPosition-10,14,9);
    doc.text(`Total Quantity`, 93, yPosition - 5);
    doc.text(totalQty.toString(), 123, yPosition - 5);
    doc.text(`Total Amount (USD):`, 148, yPosition - 5);
    doc.text(totalAmountNum.toFixed(2), 183, yPosition - 5);
    doc.text('Freight: ', 148, yPosition + 2);
    doc.text((freight || "").toString(), 186, yPosition + 2);
    doc.text('Total Amount: ', 148, yPosition + 9);
    doc.text(totalAmount.toString(), 183, yPosition + 9);

    doc.rect(x + 2, yPosition + 12, 185, 8);
    const totalAmountInWords = amountUsdToWords(totalAmountWithFreight);
    doc.text(
      `Total Amount in Words: ${totalAmountInWords}`,
      24,
      yPosition + 17
    );

    yPosition += 1;
    
    // Check if there's enough space for declaration section before drawing
    // Declaration section: y = yPosition + 5, section goes from y+10 to y+50 (40mm height)
    // So section goes from (yPosition + 15) to (yPosition + 55)
    // We need: yPosition + 55 + footerSpace <= pageHeight
    const footerSpaceLegacy2 = 25; // Space to leave at bottom for footer (page numbers)
    const declarationSectionHeight = 50; // Section extends from y+10 to y+50
    const declarationOffset = 15; // Section starts at yPosition + 15 (since y = yPosition + 5, and section starts at y+10)
    const sectionBottomOffset = declarationOffset + declarationSectionHeight; // Total: 65mm from yPosition
    const requiredSpace = sectionBottomOffset + footerSpaceLegacy2; // Total: 90mm needed
    
    // Calculate maxY correctly: yPosition + 55 + 25 <= 297, so yPosition <= 217
    // Declaration bottom = yPosition + 5 + 50 = yPosition + 55
    // We need: yPosition + 55 + footerSpace <= pageHeight
    // So: yPosition <= pageHeight - 55 - footerSpace = 297 - 55 - 25 = 217mm
    const maxY = pageHeight - 55 - footerSpaceLegacy2; // Maximum Y before needing new page (217mm)

    const declarationBottomCalc = yPosition + 55;
    const totalNeeded = declarationBottomCalc + footerSpaceLegacy2;
    
    // Check if we need a new page for declaration section
    if (yPosition > maxY) {
      doc.addPage();
      yPosition = 10; // 10mm top margin
      newpage = 1;
      // Draw border for new page (matching original layout at y=45, but adjusted for new page)
      doc.rect(x, yPosition - 5, 190, 275); // Adjusted to match original border position
    } else if (yPosition + requiredSpace > pageHeight) {
      // Double check: if adding required space would exceed page, move to next page
      doc.addPage();
      yPosition = 10; // 10mm top margin
      newpage = 1;
      doc.rect(x, yPosition - 5, 190, 275); // Reset for new page
    }
    
    y=yPosition+5;
    doc.rect(x, y + 10, 120, 40);
    doc.text("Declaration", x + 5, y + 15);
    doc.setFont("helvetica", "normal");
    const declarationText =
      "We declare that the invoice shows the actual price of goods described and that all particulars are true and correct.";
    const maxWidth = 110; // Adjust for rectangle width with padding
    const lineHeight = 5; // Space between lines
    let yOffset = y + 22; // Initial Y position

    // Split and draw text
    const lines = doc.splitTextToSize(declarationText, maxWidth);
    lines.forEach((line) => {
      if (yOffset <= y + 40) {
        // Limit to fit inside rectangle height
        doc.text(line, x + 5, yOffset);
        yOffset += lineHeight;
      }
    });
    doc.text("We intend to claim rewards under", x + 5, y + 37);
    // RODTEP text in normal font, with "Scheme" on the same line
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("RODTEP Scheme", x + 5, y + 45);

    doc.rect(x + 120, y + 10, 70, 25);
    doc.text("Company's PAN : ASAPA6292J", x + 122, y + 16);
    doc.text("Company's GST : 36ASAPA6292JIZQ", x + 122, y + 21);
    doc.text(`Company's LUT : ${companyLUT || "ASAPA54fYY2J"}`, x + 122, y + 26);
    // Draw only top, left, and right borders (no bottom line)
    doc.line(x + 120, y + 35, x + 190, y + 35); // Top line
    doc.line(x + 120, y + 35, x + 120, y + 50); // Left line
    doc.line(x + 190, y + 35, x + 190, y + 50); // Right line
    doc.text("Signature and Co. Stamp", x + 135, y + 48);
    doc.line(x + 120, y + 50, x + 190, y + 50);

    // Add page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, null, null, "center");
    }

    // Generate PDF preview URL instead of downloading
    const pdfDataUrl = doc.output("dataurlstring");
    setPdfPreviewUrl(pdfDataUrl);
  };

  const print_packing_list_legacy = () => {

    const doc = new jsPDF("p", "mm", "a4");

    //add border
    const pageWidth = doc.internal.pageSize.width;
    const pageHeight = doc.internal.pageSize.height; // For A4, it's 297 mm

    const margin = 10;

    // Add Title (with 4 line spacing from top)
    doc.setFontSize(14);
    doc.setFont("helvetica","bold");
    doc.text("PACKING LIST", pageWidth / 2, 40, null, null, "center");

    let x = 10;
    let y = 45;
    doc.rect(x, y, 190, 235);

    doc.rect(x, y, 90, 40); // Left box (x, y, width, height)

    // Add Exporter Details
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Exporter", x + 3, y + 5);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(expName || "", x + 3, y + 12);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    const from_add = doc.splitTextToSize(fromAddr || "", 80);
    doc.text(from_add, x + 3, y + 17);
    const email = doc.splitTextToSize(expPerEmail || "", 80);
    doc.text(email, x + 3, y + 27);
    const expPn = doc.splitTextToSize(expConPer || "", 80);
    doc.text(expPn, x + 3, y + 31);
    const expCn = doc.splitTextToSize(expPerNo || "", 80);
    doc.text(expCn, x + 3, y + 35);

    doc.rect(x, y + 40, 90, 46);
    // Add Consignee Details
    doc.setFontSize(8);
    doc.setFont("helvetica", "normal");
    doc.text("Consignee", x + 3, y + 47);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text(consName || "", x + 3, y + 54);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    const to_add = doc.splitTextToSize(toAddr || "", 80);
    doc.text(to_add, x + 3, y + 59);
    doc.text(conPerEmail || "", x + 3, y + 72);
    doc.text(conConPer || "", x + 3, y + 77);
    doc.text((conPerNo || "").toString(), x + 3, y + 82);

    x = x + 90;
    y = 45;
    // Invoice Details
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.rect(x, y, 40, 8);
    doc.setFontSize(9);
    doc.text("Invoice No:", x + 2, y + 5);
    doc.setFontSize(10);
    doc.text((invNo || "").toString(), x + 19, y + 5);
    let dateObj = invDate ? new Date(invDate) : new Date();
    
    // Validate date
    if (isNaN(dateObj.getTime())) {
      dateObj = new Date();
    }

    // Extract components in "DD-MM-YYYY" format
    const day = String(dateObj.getDate() || 1).padStart(2, '0');
    const month = String((dateObj.getMonth() || 0) + 1).padStart(2, '0');
    const year = dateObj.getFullYear() || new Date().getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    doc.rect(x, y + 8, 40, 10);
    doc.setFontSize(9);
    doc.text("Invoice Date: ", x + 2, y + 14);
    doc.text(formattedDate.toString(), x + 21, y + 14);

    doc.rect(x + 40, y, 60, 18);
    doc.setFontSize(10);
    doc.text("IE Code: ", x + 43, y + 10);
    doc.setFontSize(10);
    doc.text(ieCode || "", x + 58, y + 10);

    doc.rect(x, y + 18, 100, 12);
    doc.setFontSize(8);
    doc.text("Buyer's Order No: ", x + 2, y + 22);
    doc.setFontSize(10);
    doc.text(ordNo || "", x + 4, y + 27);
    doc.setFontSize(10);
    //doc.text("24216 && 25244", x + 2, y + 29);
    doc.setFontSize(10);
    // Convert the ordDate string to a Date object
    let orderDate = ordDate ? new Date(ordDate) : new Date();
    
    // Validate date
    if (isNaN(orderDate.getTime())) {
      orderDate = new Date();
    }

    // Extract components for a better date format (DD-MM-YYYY)
    const oday = String(orderDate.getDate() || 1).padStart(2, '0');
    const omonth = String((orderDate.getMonth() || 0) + 1).padStart(2, '0');
    const oyear = orderDate.getFullYear() || new Date().getFullYear();

    const formattedOrderDate = `${oday}-${omonth}-${oyear}`;
    doc.setFontSize(9);
    doc.text("Dated: ", x + 40, y + 23);
    doc.setFontSize(11);
    doc.text(formattedOrderDate.toString(), x + 52, y + 23);
    //doc.text("Dated: 12-Jan-2025", x + 48, y + 29);
    doc.setFontSize(10);
    //Buyer details
    doc.rect(x, y + 30, 100, 26);
    doc.text("Buyer (if other than consignee)", x + 2, y + 35);
    doc.setFontSize(9);
    doc.text(doc.splitTextToSize(buyerId || "", 95), x + 2, y + 42);
    doc.setFontSize(10);
    doc.rect(x, y + 56, 100, 10);
    doc.setFontSize(10);
    doc.text("Country of Manufacture : ", x + 2, y + 61);
    doc.text(conMan || "", x + 50, y + 61);
    doc.rect(x, y + 66, 100, 10);
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Country of Export : ", x + 2, y + 70);
    doc.text(conExp || "", x + 50, y + 70);
    doc.rect(x, y + 76, 100, 10);
    doc.text("Country of Final Destination : ", x + 2, y + 80);
    doc.text(conDest || "", x + 50, y + 80);

    //payment details
    doc.rect(x, y + 86, 100, 35);
    doc.text("Terms of delivery and payment:", x + 2, y + 92);
    const terms = doc.splitTextToSize(termsDnP || "", 90);
    doc.text(terms, x + 2, y + 110);

    //carrier details
    x = 10;
    y = 133;
    doc.rect(x, y - 2, 35, 13);
    doc.text("Pre-Carriage By:", x + 2, y + 4);
    doc.text(preCarr || "", x + 5, y + 9);

    doc.rect(x + 35, y - 2, 55, 13);
    doc.text("Place of reciept by pre-carrier:", x + 37, y + 4);

    doc.rect(x, y + 11, 35, 11);
    doc.text("Vessel/flight No:", x + 2, y + 15);
    if (flightNo) { doc.text(flightNo, x + 2, y + 19); }

    doc.rect(x + 35, y + 11, 55, 11);
    doc.text("Port of loading:", x + 37, y + 15);
    if (portLoad) { doc.text(portLoad, x + 37, y + 19); }
    doc.rect(x, y + 22, 35, 11);
    doc.text("Port of Discharge:", x + 2, y + 26);
    doc.text(portDis || "", x + 2, y + 31);

    doc.rect(x + 35, y + 22, 55, 11);
    doc.text("Final Destination:", x + 37, y + 26);
    doc.text(finalDest || "", x + 37, y + 31);

    // Invoice Items Table
    const tableData = invoiceItemList.map((item, index) => ({
      sno: index + 1, // Increment index starting from 1
      description: item.des || "N/A", // Handle undefined values
      hsnCode: item.hsncode || "N/A",
      partnum: item.partnum || "", // Ensure part number is available for the table
      quantity: item.quantity || 0,
      countryOfOrigin: item.con || "N/A",
      rate: item.price || 0,
      amount: (item.quantity || 0) * (item.price || 0), // Calculate amount dynamically
      netWeight: item.netwt || 0, // Add netWeight property
    }));

    const headers = [
      ["S.No", "Description", "HSN Code", "Part Number", "Qty", "Country of Origin",  "Net Weight KG"],
    ];

    // Automatically map table rows based on dynamic data
    const bodyData = tableData.map((item, index) => [
      index + 1,
      item.description,
      item.hsnCode,
      item.partnum,
      Number(item.quantity.toString()),
      item.countryOfOrigin,
      Number((item.netWeight || 0).toString())
    ]);

    let yPosition = y + 37;
    let currentPage = 1; // Track current page number

    autoTable(doc, {
      startY: yPosition,
      head: headers,
      body: bodyData,
      theme: "grid",
      // Prevent splitting a row across pages. If a row doesn't fit, move it fully to the next page.
      // (If a single row is taller than a page, autoTable will still have to split it.)
      rowPageBreak: "avoid",
      margin: { left: 15, right: 15, bottom: 25 },
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [0, 0, 0], // RGB color for the border
        lineWidth: 0.5,       // Border line width
        overflow: "linebreak",
        tableLineWidth: 0.5,
        tableLineColor: [0, 0, 0],
      },
      bodyStyles: {
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        1: { cellWidth: 60 }, // For long text wrapping in Description
        3: { halign: "center" }, // Center Country of Origin column
        4: { halign: "center" }, // Center Qty column
        5: { halign: "center" }, // Center Rate column
        6: { halign: "center" }, // Center Amount column
      },
      headStyles: {
        fillColor: [235, 235, 235],
        textColor: [0, 0, 0],
        lineWidth: 0.5, // Add border width for header
        lineColor: [0, 0, 0], // Black grid lines for header
      },
    });
  
    // Check if lastAutoTable exists before accessing finalY
    let newpage = 0;
    if (doc.lastAutoTable && doc.lastAutoTable.finalY !== undefined) {
      // autoTable's finalY is relative to the page it ended on
      // autoTable automatically handles page breaks, so finalY is always valid
      yPosition = doc.lastAutoTable.finalY + 10;
      
      // Check if autoTable added pages by comparing page count
      const totalPages = doc.internal.getNumberOfPages();
      if (totalPages > currentPage) {
        currentPage = totalPages;
        newpage = 1;
      }
    } else {
      // Fallback if table wasn't created
      yPosition = y + 37 + (bodyData.length * 10) + 10;
    }
    
    doc.setFont("helvetica", "normal");
    
    // Use pageHeight-based check instead of hardcoded 270
    // Leave footer space (25mm) to avoid printing in footer area
    const footerSpaceLegacy3 = 25;
    const safePageThreshold = pageHeight - footerSpaceLegacy3;
    if (yPosition > safePageThreshold) {
      doc.addPage();
      yPosition = 10; // 10mm top margin
      newpage = 1;
      currentPage++;
    }
    
    // Calculate total quantity for box table (needed for totals row)
    const totalQty = tableData.reduce((sum, item) => sum + Number(item.quantity), 0);
    
    yPosition -= 4;
    
    // Box Details Table with 9 columns
    if (invoiceBoxList && invoiceBoxList.length > 0) {
      // Check if we need a new page - use pageHeight-based check instead of hardcoded 250
      // Need space for box table + declaration section (estimate ~80mm total)
      const boxTableSpaceNeeded = 80;
      if (yPosition + boxTableSpaceNeeded > pageHeight && newpage === 0) {
        doc.addPage();
        yPosition = 10; // 10mm top margin
        newpage = 1;
        currentPage++;
        doc.rect(x, yPosition - 15, 190, 275); // Reset for new page
      }

      // Prepare box data
      const boxRows = invoiceBoxList.map((box) => {
        const length = Number(box.boxl || 0);
        const width = Number(box.boxb || 0);
        const height = Number(box.boxw || 0);
       
        
        return [
          String(box.boxno || ""),
          String(Number(box.boxwt || 0).toFixed(2)), // Weight (Gross Weight)
          String(length),
          String(width),
          String(height),
          "", // Empty column 6
          "", // Empty column 7
        ];
      });

      // Calculate totals
      const totalPackages = invoiceBoxList.length;
      const totalQuantity = tableData.reduce((sum, item) => sum + Number(item.quantity || 0), 0);
      // Calculate total gross weight as sum of all box weights
      const totalGrossWeight = invoiceBoxList.reduce((sum, box) => sum + Number(box.boxwt || 0), 0);
      // Calculate total net weight as sum of all box net weights
      const totalNetWeight = invoiceBoxList.reduce((sum, box) => sum + Number(box.boxnetwt || 0), 0);

      // Add fixed total rows at the end of the table
      // Use objects with colspan for merged cells - merge columns 0-6
      boxRows.push([
        { content: "Total Packages", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } }, // Columns 0-5 merged
        String(totalPackages), // Column 6 - value
      ]);
      boxRows.push([
        { content: "Total Quantity", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } }, // Columns 0-5 merged
        String(totalQuantity), // Column 6 - value
      ]);
      boxRows.push([
        { content: "Total Gross Weight", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } }, // Columns 0-5 merged
        `${totalGrossWeight.toFixed(2)} kgs`, // Column 6 - value (sum of all box weights)
      ]);
      boxRows.push([
        { content: "Total Net Weight", colSpan: 6, styles: { halign: "right", fontStyle: "bold" } }, // Columns 0-5 merged
        `${totalNetWeight.toFixed(2)} kgs`, // Column 6 - value
      ]);

      // Table headers
      const boxTableHeaders = [
        ["Box No", "Weight (Kgs)","L (cms)", "W (cms)", "H (cms)", "", ""],
      ];

      // Find the index where totals start
      const totalRowsStartIndex = invoiceBoxList.length;

      autoTable(doc, {
        startY: yPosition,
        head: boxTableHeaders,
        body: boxRows,
        theme: "grid",
        // Avoid splitting a box row across pages for better readability.
        rowPageBreak: "avoid",
        margin: { left: 15, right: 15, bottom: 25 },
        styles: {
          fontSize: 8,
          cellPadding: 2,
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
          overflow: "linebreak",
          tableLineWidth: 0.5,
          tableLineColor: [0, 0, 0],
        },
        bodyStyles: {
          lineColor: [0, 0, 0],
          lineWidth: 0.5,
        },
        columnStyles: {
          0: { halign: "center", cellWidth: 20 },
          1: { halign: "right", cellWidth: 25 },
          2: { halign: "right", cellWidth: 25 }, // Net Weight column
          3: { halign: "right", cellWidth: 20 },
          4: { halign: "right", cellWidth: 20 },
          5: { halign: "center", cellWidth: 15 },
          6: { halign: "right", cellWidth: 25 },
        },
        headStyles: {
          fillColor: [235, 235, 235],
          textColor: [0, 0, 0],
          lineWidth: 0.5,
          lineColor: [0, 0, 0],
          fontStyle: "bold",
        },
        // Style the last 4 rows (totals) differently - make them bold and properly aligned
        didParseCell: function (data) {
          const rowIndex = data.row.index;
          // Check if this is one of the total rows (last 4 rows)
          if (rowIndex >= totalRowsStartIndex) {
            // Right align the value column (column 7)
            if (data.column.index === 7) {
              data.cell.styles.fontStyle = "bold";
              data.cell.styles.halign = "right";
            }
            // Column 0 should be empty and not styled
            if (data.column.index === 0) {
              data.cell.styles.fontStyle = "normal";
            }
          }
        },
      });

      // Update yPosition after box table
      if (doc.lastAutoTable && doc.lastAutoTable.finalY !== undefined) {
        // autoTable's finalY is relative to the page it ended on
        // autoTable automatically handles page breaks, so finalY is always valid
        yPosition = doc.lastAutoTable.finalY + 10;
        
        // Check if autoTable added pages
        const totalPages = doc.internal.getNumberOfPages();
        if (totalPages > currentPage) {
          currentPage = totalPages;
          newpage = 1;
        }
      } else {
        yPosition = yPosition + (boxRows.length * 6) + 10;
        // Check if this exceeds pageHeight
        if (yPosition > pageHeight) {
          doc.addPage();
          yPosition = 10; // 10mm top margin
          newpage = 1;
          currentPage++;
          doc.rect(x, yPosition - 15, 190, 275);
        }
      }
    } else {
      yPosition += 10;
    }
    
    // Check if there's enough space for the last section and footer space
    // Section: y = yPosition - 15, section goes from y+10 to y+50 (40mm height)
    // So section goes from (yPosition - 5) to (yPosition + 35)
    // We need: yPosition + 35 + footerSpace <= pageHeight
    const footerSpaceLegacy4 = 25; // Space to leave at bottom
    const sectionBottomOffset = 35; // Section extends 35mm below yPosition (y+50 where y=yPosition-15)
    const requiredSpace = sectionBottomOffset + footerSpaceLegacy4; // Total: 60mm
    const maxY = pageHeight - footerSpaceLegacy4 - sectionBottomOffset; // Maximum Y before needing new page (237mm)
    
    // Check if we need a new page for the last section (works on any page)
    // Ensure yPosition is relative to current page - use stricter check
    if (yPosition > maxY) {
      // If we're too close to the bottom, move to next page
      doc.addPage();
      yPosition = 45; // 10mm top margin
      newpage = 1;
      currentPage++;
      doc.rect(x, yPosition-10, 190, 245); // Reset for new page
    } else if (yPosition + requiredSpace > pageHeight) {
      // Double check: if adding required space would exceed page, move to next page
      doc.addPage();
      yPosition = 40; // 10mm top margin
      newpage = 1;
      currentPage++;
      doc.rect(x, yPosition, 190, 245); // Reset for new page
    }
    
    y=yPosition-15;
    doc.rect(x, y + 10, 120, 40);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    doc.text("Declaration", x + 5, y + 15);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    const declarationText =
      "We declare that all the particulars provided by Exporter are correct.";
    const maxWidth = 110; // Adjust for rectangle width with padding
    const lineHeight = 5; // Space between lines
    let yOffset = y + 22; // Initial Y position

    // Split and draw text
    const lines = doc.splitTextToSize(declarationText, maxWidth);
    lines.forEach((line) => {
      if (yOffset <= y + 40) {
        // Limit to fit inside rectangle height
        doc.text(line, x + 5, yOffset);
        yOffset += lineHeight;
      }
    });
    doc.text("We intend to claim rewards under", x + 5, y + 25);
    // RODTEP text in normal font, with "Scheme" on the same line
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    doc.text("RODTEP Scheme", x + 5, y + 30);

    doc.rect(x + 120, y + 10, 70, 25);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(9);
    doc.text("Company's PAN : ASAPA6292J", x + 122, y + 16);
    doc.text("Company's GST : 36ASAPA6292JIZQ", x + 122, y + 21);
    doc.text(`Company's LUT : ${companyLUT || "ASAPA54fYY2J"}`, x + 122, y + 26);
    // Draw only top, left, and right borders (no bottom line)
    doc.line(x + 120, y + 35, x + 190, y + 35); // Top line
    doc.line(x + 120, y + 35, x + 120, y + 50); // Left line
    doc.line(x + 190, y + 35, x + 190, y + 50); // Right line
    doc.text("Signature and Co. Stamp", x + 135, y + 48);
    doc.line(x + 120, y + 50, x + 190, y + 50);

    // Add page numbers
    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      doc.text(`Page ${i} of ${totalPages}`, pageWidth / 2, pageHeight - 10, null, null, "center");
    }

    // Generate PDF preview URL instead of downloading
    const pdfDataUrl = doc.output("dataurlstring");
    setPdfPreviewUrl(pdfDataUrl);
  };

  const buildPrintModel = () =>
    buildInvoicePrintModel({
      toAddr,
      fromAddr,
      expName,
      expConPer,
      expPerNo,
      expPerEmail,
      consName,
      conConPer,
      conPerNo,
      conPerEmail,
      invoiceItemList,
      invoiceBoxList,
      freight,
      preCarr,
      companyLUT,
      flightNo,
      portDis,
      placeRecip,
      portLoad,
      finalDest,
      buyerId,
      conMan,
      conExp,
      conDest,
      invNo,
      invDate,
      ieCode,
      ordNo,
      ordDate,
      termsDnP,
    });

  const print_inv = () => {
    const model = buildPrintModel();
    setPdfPreviewUrl(generateInvoicePdfDataUrl(model));
  };

  const print_packing_list = () => {
    const model = buildPrintModel();
    setPdfPreviewUrl(generatePackingListPdfDataUrl(model));
  };

  const downloadPdf = () => {
    if (pdfPreviewUrl) {
      const link = document.createElement("a");
      link.href = pdfPreviewUrl;
      link.download = `invoice-${invNo || "invoice"}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };


  return (
    <div className="invoice-container">
      <span className="app-version-badge" aria-label={`App version ${APP_VERSION}`}>
        v{APP_VERSION}
      </span>
      <h1 className="text-center">Alico Invoices</h1>
      <div className="file-upload-section">
        <div className="form-field" style={{ maxWidth: "300px" }}>
          <label htmlFor="file" className="form-label">File</label>
          <input type="file" id="input" className="form-input" onChange={handleFileUpload} />
        </div>
        <div style={{ paddingTop: "32px" }}>
          <button className="btn" onClick={() => handleFileImport()}>Import</button>
        </div>
      </div>
      <div className="responsive-grid">
        {exporterDetails()}
          {consigneDetails()}
        {invoiceDetails()}
        </div>
      {shippingDetails()}
      {carrierDetails()}
      {handlingDetails()}
      {PaymentDetails()}
      <div className="modern-section">
        <h2 className="section-title">Item Details</h2>
        <div className="responsive-grid-2" style={{ alignItems: "start" }}>
          <div>{newItemDetails()}</div>
          <div style={{ alignSelf: "start" }}>{calcDetail()}</div>
        </div>
        {invoiceItemList.length > 0 ? itemTableDetails() : null}
      </div>
      <div className="modern-section">
        <h2 className="section-title">Box Details</h2>
        <div className="responsive-grid-2" style={{ alignItems: "start" }}>
          <div>{newBoxDetails()}</div>
          <div style={{ alignSelf: "start" }}>{calcBox()}</div>
        </div>
          {invoiceBoxList.length > 0 ? boxTableDetails() : null}
        </div>
      <div className="action-buttons">
        <button className="btn" onClick={() => writeXl()}>Download Excel</button>
        <button className="btn" onClick={() => print_inv()}>Preview Invoice PDF</button>
        <button className="btn" onClick={() => print_packing_list()}>Preview Packing List PDF</button>
        {pdfPreviewUrl && (
          <button className="btn" onClick={downloadPdf}>Download PDF</button>
        )}
      </div>

      {/* PDF Preview Section */}
      {pdfPreviewUrl && (
        <div className="pdf-preview-container">
          <div className="flex-row justify-between mb-16">
            <h3>PDF Preview</h3>
            <button
              className="btn btn-danger"
              onClick={() => setPdfPreviewUrl(null)}
            >
              Close Preview
            </button>
          </div>
          <iframe
            src={pdfPreviewUrl}
            style={{
              width: "100%",
              height: "800px",
              border: "1px solid var(--color-border)",
              borderRadius: "8px",
            }}
            title="PDF Preview"
          />
        </div>
      )}
    </div>
  );
}

export default Invoices;


